
export const isiOS = () => {
  const UA = navigator.userAgent
  return !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}
// 判断是否大于该客户端版本号
// 如果传入数组，则顺序为[iOS_version, android_version]
export default function(target) {
  const nowVersion = localStorage.getItem('STORAGE_VERSION')
  // 没有获取到当前版本号，则认为是最新版本or开发环境，返回true
  if (!nowVersion) return true
  let targetVersion = target
  if (typeof target === 'object') {
    targetVersion = isiOS() ? target[0] : target[1]
  }
  const arr1 = nowVersion.split('.').map(item => +item)
  const arr2 = targetVersion.split('.').map(item => +item)
  let result = 0
  while (arr1.length && arr2.length) {
    const val1 = arr1.shift()
    const val2 = arr2.shift()
    if (val1 === val2) {
      result = 0
    } else {
      result = val1 > val2 ? 1 : -1
      break
    }
  }
  if (result === 0) {
    result = arr1.some(item => item) ? 1 : arr2.some(item => item) ? -1 : 0
  }
  return result > -1
}
